import { Component, Input, Output, EventEmitter } from '@angular/core';
import { toNumber, toBoolean } from '../util';

import { NoticeItem } from './interface';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'notice-icon',
  template: `
  <nz-badge *ngIf="data?.length === 0" [nzCount]="count">
    <i class="anticon anticon-bell"></i>
  </nz-badge>
  <nz-popover *ngIf="data?.length > 0"
    [nzVisible]="popoverVisible" (nzVisibleChange)="onVisibleChange($event)" nzTrigger="click"
    nzPlacement="bottomRight"
    nzOverlayClassName="ad-notice-icon-con">
    <div nz-popover class="item">
      <nz-badge [nzCount]="count">
        <i class="anticon anticon-bell"></i>
      </nz-badge>
    </div>
    <ng-template #nzTemplate>
      <nz-spin [nzSpinning]="loading" [nzDelay]="0">
        <nz-tabset>
          <nz-tab *ngFor="let i of data" [nzTitle]="i.title">
            <notice-icon-tab
              [data]="i"
              (select)="onSelect($event)"
              (clear)="onClear($event)"></notice-icon-tab>
          </nz-tab>
        </nz-tabset>
      </nz-spin>
    </ng-template>
  </nz-popover>
  `,
  // tslint:disable-next-line:use-host-property-decorator
  host: { '[class.ad-notice-icon]': 'true' },
  preserveWhitespaces: false,
})
export class NoticeIconComponent {
  @Input() data: NoticeItem[] = [];

  /** å¾æ ä¸çæ¶æ¯æ»æ° */
  @Input()
  get count() {
    return this._count;
  }
  set count(value: any) {
    this._count = toNumber(value);
  }
  private _count: number;

  /** å¼¹åºå¡çå è½½ç¶æ */
  @Input()
  get loading() {
    return this._loading;
  }
  set loading(value: any) {
    this._loading = toBoolean(value);
  }
  private _loading = false;

  @Output() select = new EventEmitter<any>();
  @Output() clear = new EventEmitter<string>();

  /** æå¨æ§å¶Popoveræ¾ç¤º */
  @Input()
  get popoverVisible() {
    return this._popoverVisible;
  }
  set popoverVisible(value: any) {
    this._popoverVisible = toBoolean(value);
  }
  private _popoverVisible = false;

  @Output() popoverVisibleChange = new EventEmitter<boolean>();

  onVisibleChange(result: boolean) {
    this.popoverVisibleChange.emit(result);
  }

  onSelect(i: any) {
    this.select.emit(i);
  }

  onClear(title: string) {
    this.clear.emit(title);
  }
}
